import { useEffect } from 'react';

const DEFAULT_OG_IMAGE = 'https://media.base44.com/images/public/6a54fc37929928fd03a2219b/62b80148d_logo.jpg/v1/fill/w_1200,h_630/62b80148d_logo.jpg';
const SITE_NAME = 'Daley Inventories';

function upsertMeta(attr, key, content) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
  return el;
}

function upsertLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
  return el;
}

export default function Seo({ title, description, canonical, ogType = 'website', ogImage = DEFAULT_OG_IMAGE, jsonLd }) {
  useEffect(() => {
    const prevTitle = document.title;
    const descMeta = document.querySelector('meta[name="description"]');
    const prevDesc = descMeta?.content || '';
    const pageUrl = canonical || window.location.href.split('#')[0];

    if (title) document.title = title;
    if (description) {
      let meta = descMeta;
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = 'description';
        document.head.appendChild(meta);
      }
      meta.content = description;
    }

    upsertLink('canonical', pageUrl);

    upsertMeta('property', 'og:site_name', SITE_NAME);
    upsertMeta('property', 'og:locale', 'en_GB');
    upsertMeta('property', 'og:type', ogType);
    upsertMeta('property', 'og:title', title || '');
    upsertMeta('property', 'og:description', description || '');
    upsertMeta('property', 'og:url', pageUrl);
    upsertMeta('property', 'og:image', ogImage);

    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', title || '');
    upsertMeta('name', 'twitter:description', description || '');
    upsertMeta('name', 'twitter:image', ogImage);

    let scriptEl = null;
    if (jsonLd) {
      scriptEl = document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.text = JSON.stringify(jsonLd);
      scriptEl.setAttribute('data-seo', 'true');
      document.head.appendChild(scriptEl);
    }

    return () => {
      document.title = prevTitle;
      if (descMeta) descMeta.content = prevDesc;
      if (scriptEl) scriptEl.remove();
    };
  }, [title, description, canonical, ogType, ogImage, jsonLd]);

  return null;
}